/**
 * Nexus design tokens (Phase 7.2).
 * Semantic names map to existing GitHub-dark palette — no rebrand.
 */
export const nexusTokens = {
  colors: {
    surface: {
      default: '#0d1117',
      paper: '#161b22',
      elevated: '#21262d',
    },
    border: {
      default: '#30363d',
      subtle: 'rgba(48, 54, 61, 0.5)',
    },
    text: {
      primary: '#f0f6fc',
      secondary: '#8b949e',
      muted: '#7d8590',
      disabled: '#484f58',
    },
    accent: {
      primary: '#58a6ff',
      secondary: '#f78166',
      success: '#238636',
      warning: '#d29922',
      error: '#da3633',
    },
    gradient: {
      surface: 'linear-gradient(135deg, #161b22 0%, #21262d 100%)',
      surfaceVertical: 'linear-gradient(180deg, #161b22 0%, #21262d 100%)',
      primaryButton: 'linear-gradient(135deg, #58a6ff 0%, #1f6feb 100%)',
    },
  },
  spacing: {
    page: 24,
    section: 32,
    cardPadding: 24,
    tableCellY: 16,
    tableCellX: 16,
  },
  radius: {
    sm: 4,
    md: 6,
    lg: 8,
    xl: 10,
  },
  typography: {
    pageTitle: {
      fontWeight: 600,
      fontSize: '2rem',
      lineHeight: 1.3,
      letterSpacing: '-0.01em',
    },
    pageSubtitle: {
      fontWeight: 400,
      fontSize: '1rem',
      lineHeight: 1.5,
    },
    metricLabel: {
      fontWeight: 600,
      fontSize: '0.9rem',
      lineHeight: 1.4,
    },
    metricValue: {
      fontWeight: 800,
      fontSize: '2.5rem',
      lineHeight: 1.1,
      letterSpacing: '-0.02em',
    },
    metricValueFeatured: {
      fontWeight: 800,
      fontSize: '3.5rem',
      lineHeight: 1,
      letterSpacing: '-0.02em',
    },
  },
};

/** Read tokens from MUI theme or fall back to static export. */
export function getNexusTokens(theme) {
  return theme?.nexus ?? nexusTokens;
}
